// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from '../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type StartWorkspaceAiChatMutationVariables = Types.Exact<{
  input: Types.StartWorkspaceAiChatInput;
}>;


export type StartWorkspaceAiChatMutation = { __typename?: 'Mutation', startWorkspaceAiChat: { __typename?: 'AiChatSession', id: string, workspaceId: string, scopeType: Types.AiChatScopeType, status: Types.AiChatSessionStatus, scopeDocumentCollectionId?: string | null, title: string, createdAt: any, updatedAt: any } };


export const StartWorkspaceAiChatDocument = gql`
    mutation StartWorkspaceAiChat($input: StartWorkspaceAiChatInput!) {
  startWorkspaceAiChat(input: $input) {
    id
    workspaceId
    scopeType
    status
    scopeDocumentCollectionId
    title
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useStartWorkspaceAiChatMutation__
 *
 * To run a mutation, you first call `useStartWorkspaceAiChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartWorkspaceAiChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startWorkspaceAiChatMutation, { data, loading, error }] = useStartWorkspaceAiChatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartWorkspaceAiChatMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartWorkspaceAiChatMutation, StartWorkspaceAiChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartWorkspaceAiChatMutation, StartWorkspaceAiChatMutationVariables>(StartWorkspaceAiChatDocument, options);
      }
export type StartWorkspaceAiChatMutationHookResult = ReturnType<typeof useStartWorkspaceAiChatMutation>;
export type StartWorkspaceAiChatMutationResult = ApolloReactCommon.MutationResult<StartWorkspaceAiChatMutation>;